<template>
  <section class="wrapper-outer wrapper-about">
    <div class="wrapper-inner about">
      <img
        class="about__avatar"
        src="@/assets/img/2-About/port_avatar.webp"
        alt=""
      />
      <div class="about-content">
        <h2 class="ta-c">Обо мне</h2>
        <p class="about__text ta-c">
          Привет, меня зовут Дмитрий и я начинающий фронетенд разработчик.
          <br />
          <br />
          Мне интересно создовать красивые и функиональные интерфейсы.
          <br />
          <br />
          Готов реализовывать интересные проекты в команде с профессионалами и
          учиться новому.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "About",
};
</script>
